// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__2_A9C","selects":"Documents_selects__dhMU9"};